
		<div class="form-group" [formGroup]="OBJ_form_group" [ngClass]="{'has-error': isInvalid()}">
			<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
				<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon" [tooltip]="tooltipTemplate" placement="top" triggers="click" containerClass="tig-tooltip" delay="50"></i>
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span>
			</label>
			<div class="col-lg-8">
				<input title="{{getHint()|translate}}"
					class="form-control"
					[placeholder]="getLabelName()|translate"
					[formControlName]="OBJ_field_config.name"
					(change)="modelChanged($event)"
					(blur)="setValue($event)"
				/>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
				<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
				<div *ngIf="ARR_proposals">
					<a *ngFor="let OBJ_entry of this.ARR_proposals"
						href="{{ STR_route + OBJ_contents_helper.findId(OBJ_entry)}}"
						target="_blank">{{"oMisc.sEntryFound"|translate}} <i class="fa fa-external-link"></i>
					</a>
				</div>
			</div>
		</div>
	